import React, { useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import TimeSheetTab from './TimeSheetTab';
import MyPtoTab from './MyPtoTab';
import PtoSettingsTab from './PtoSettingsTab';
import HolidaysTab from './HolidaysTab';
import './Salon.css';

const VALID_TABS = new Set(['myHours', 'myPto', 'ptoSettings', 'holidays']);

const ManageTimeOff = ({ salonId, userRole, activeTab: activeTabFromUrl, onTabChange }) => {
  const { t } = useLanguage();
  const isAdmin = userRole === 'owner' || userRole === 'admin';
  const activeTab = VALID_TABS.has(activeTabFromUrl) ? activeTabFromUrl : 'myPto';

  // Defensive: if a non-admin ever ends up on an admin-only tab (e.g. a stale/shared link), fall back
  useEffect(() => {
    if (!isAdmin && (activeTab === 'ptoSettings' || activeTab === 'holidays')) {
      onTabChange('myPto', { replace: true });
    }
  }, [isAdmin, activeTab, onTabChange]);

  return (
    <div className="manage-page time-off-page">
      <div className="table-header">
        <h3>{t('timeOff.title')}</h3>
      </div>

      <div className="time-off-tabs-wrapper">
        <div className="time-off-tabs">
          <button
            className={`time-off-tab ${activeTab === 'myPto' ? 'active' : ''}`}
            onClick={() => onTabChange('myPto')}
          >
            {isAdmin ? t('timeOff.tabs.pto') : t('timeOff.tabs.myPto')}
          </button>
          <button
            className={`time-off-tab ${activeTab === 'myHours' ? 'active' : ''}`}
            onClick={() => onTabChange('myHours')}
          >
            {isAdmin ? t('timeOff.tabs.timeSheets') : t('timeOff.tabs.myHours')}
          </button>
          {isAdmin && (
            <button
              className={`time-off-tab ${activeTab === 'ptoSettings' ? 'active' : ''}`}
              onClick={() => onTabChange('ptoSettings')}
            >
              {t('timeOff.tabs.ptoSettings')}
            </button>
          )}
          {isAdmin && (
            <button
              className={`time-off-tab ${activeTab === 'holidays' ? 'active' : ''}`}
              onClick={() => onTabChange('holidays')}
            >
              {t('timeOff.tabs.holidays')}
            </button>
          )}
        </div>
      </div>

      <div className="time-off-tab-content">
        {activeTab === 'myPto' && <MyPtoTab salonId={salonId} userRole={userRole} />}
        {activeTab === 'myHours' && <TimeSheetTab salonId={salonId} userRole={userRole} />}
        {activeTab === 'ptoSettings' && isAdmin && <PtoSettingsTab salonId={salonId} />}
        {activeTab === 'holidays' && isAdmin && <HolidaysTab salonId={salonId} />}
      </div>
    </div>
  );
};

export default ManageTimeOff;
